import { Skeleton, Typography } from '@mui/material';
import { RecipeHeader } from 'common/src/api/models/recipe-header.models';
import { recipesSlice } from 'common/src/store/recipes';
import {
  CfDataGridTableViewDefinitions,
  CfDataGridValueGetterProps,
  CfRecomputeRowHeightsRefCallback,
} from '../../../../cf-ui/DataGrid/CfDataGridProps';
import RecipeCategoryGridRow from '../../../recipes/components/RecipeCategoryGrid/RecipeCategoryGridRow';
import { RecipeCategoryGridRowCollapseButton } from '../../../recipes/components/RecipeCategoryGrid/RecipeCategoryGridRowCollapseButton';

export const createTableViewDefinitions = (
  recomputeRowHeightsRef: CfRecomputeRowHeightsRefCallback,
  renderActionComponentLeft?: (recipe: RecipeHeader) => React.ReactNode,
  renderActionComponentRight?: (recipe: RecipeHeader) => React.ReactNode
): CfDataGridTableViewDefinitions<RecipeHeader> => {
  return {
    xs: {
      virtualizedProps: {
        enabled: true,
        recomputeRowHeightsRef: recomputeRowHeightsRef,
        contained: true,
        maxHeight: '355px',
      },
      showHeader: false,
      bodyTableRowProps: (item) => ({
        sx: {
          alignItems: 'center',
          '&:hover': { backgroundColor: '#f5f5f5' },
          height: item?.IsCollapsed ? 0 : 'unset',
          minHeight: item?.IsCollapsed ? 0 : '50px',
        },
      }),
      insertCustomRow: (previous, next, recomputeRowHeights) => {
        if (next.item && (!previous.item || previous.item?.RecipeCategoryId !== next.item?.RecipeCategoryId))
          return {
            tableRowSxProps: {
              borderBottom: (theme) => '1px solid ' + theme.palette.coolGrey[200],
            },
            content: (
              <RecipeCategoryGridRow
                minimal
                categoryName={next.item.CategoryName}
                categoryId={next.item.RecipeCategoryId || ''}
                recomputeRowHeights={recomputeRowHeights}
                actionComponent={
                  <RecipeCategoryGridRowCollapseButton
                    isCollapsed={next.item.IsCollapsed ?? false}
                    categoryId={next.item.RecipeCategoryId || ''}
                    collapseAction={recipesSlice.actions.updateCategoryIsCollapsed}
                  />
                }
              />
            ),
          };
      },
      columns: [
        ...(renderActionComponentLeft
          ? [
              {
                title: '',
                width: 'fit-content',
                value: function Left(props: CfDataGridValueGetterProps<RecipeHeader>) {
                  if (!props.recomputeRowHeights || props.item.IsCollapsed) return <></>;
                  return renderActionComponentLeft?.(props.item) ?? <></>;
                },
                loadingPlaceholder: <Skeleton variant='rectangular' width='100%' />,
              },
            ]
          : []),
        {
          title: '',
          width: '85%',
          value: function RecipeName(props) {
            if (!props.recomputeRowHeights || props.item.IsCollapsed) return <></>;

            return (
              <Typography variant='responsiveParagraph' textAlign='left'>
                {props.item.RecipeName}
              </Typography>
            );
          },
          loadingPlaceholder: <Skeleton variant='rectangular' width='100%' />,
        },
        ...(renderActionComponentRight
          ? [
              {
                title: '',
                width: 'fit-content',
                value: function Right(props: CfDataGridValueGetterProps<RecipeHeader>) {
                  if (!props.recomputeRowHeights || props.item.IsCollapsed) return <></>;
                  return renderActionComponentRight?.(props.item) ?? <></>;
                },
                loadingPlaceholder: <Skeleton variant='rectangular' width='100%' />,
              },
            ]
          : []),
      ],
    },
  };
};
